export enum FieldType {
  BOOLEAN = 'BOOLEAN',

  DATE = 'DATE',

  LABEL = 'LABEL',
  TEXT = 'TEXT',

  // Numeric types
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  CURRENCY = 'CURRENCY',
  PERCENTAGE = 'PERCENTAGE',
  CONTRACT = 'CONTRACT',
  PAY_VALUE = 'PAY_VALUE',

  // Selection from pre-defined set of values
  LIST = 'LIST',
  ENTITY = 'ENTITY',
  ENTITY_DATA = 'ENTITY_DATA',
  ENTITY_PREFIXED = 'ENTITY_PREFIXED',
  TREE = 'TREE',
  PEOPLE_TREE = 'PEOPLE_TREE',

  PHOTO = 'PHOTO',
  WORK_CYCLE_TABLE = 'WORK_CYCLE_TABLE',
  ACTIVE_EMPLOYEE = 'ACTIVE_EMPLOYEE',
  BREAK_LINE = 'BREAK_LINE',
  BLANK = 'BLANK',
  FILE = 'FILE',
  FILES = 'FILES',
  ID = 'ID',
  ABSENCE = 'Absence',
  AUTO_GENERATED = 'AUTO_GENERATED'
}

export const FieldTypesEntity = [FieldType.ENTITY, FieldType.ENTITY_DATA, FieldType.ENTITY_PREFIXED];

export enum InputMaskValidationType {
  NOT_BLANK = 'NOT_BLANK',
  BIC = 'BIC',
  IBAN = 'IBAN',
  BSB = 'BSB',
  SSNFrance = 'SSNFrance',
  EMAIL = 'EMAIL',
}
